import {
  battleNetIcon,
  dimEngramIcon,
  dimHunterIcon,
  dimPowerAltIcon,
  dimPowerIcon,
  dimTitanIcon,
  dimWarlockIcon,
  stadiaIcon,
} from './custom';

const faArchive = 'fas fa-archive';
const faArrowCircleUp = 'fas fa-arrow-circle-up';
const faArrowRight = 'fas fa-arrow-right';
const faBan = 'fas fa-ban';
const faBars = 'fas fa-bars';
const faBolt = 'fas fa-bolt';
const faCheck = 'fas fa-check';
const faCheckCircle = 'fas fa-check-circle';
const faCheckCircleRegular = 'far fa-check-circle';
const faChevronCircleUp = 'fas fa-chevron-circle-up';
const faChevronCircleDown = 'fas fa-chevron-circle-down';
const faCircleRegular = 'far fa-circle';
const faCog = 'fas fa-cog';
const faCopy = 'fas fa-copy';
const faDownload = 'fas fa-file-export';
const faEnvelope = 'fas fa-envelope';
const faEraser = 'fas fa-eraser';
const faLevelUpAlt = 'fas fa-level-up-alt';
const faLock = 'fas fa-lock';
const faUnlock = 'fas fa-unlock';
const faCaretDown = 'fas fa-caret-down';
const faPencilAlt = 'fas fa-pencil-alt';
const faPlus = 'fas fa-plus';
const faCaretRight = 'fas fa-caret-right';
const faAngleRight = 'fas fa-angle-right';
const faAngleLeft = 'fas fa-angle-left';
const faAngleDoubleLeft = 'fas fa-angle-double-left';
const faAngleDoubleRight = 'fas fa-angle-double-right';
const faPlusCircle = 'fas fa-plus-circle';
const faPlusSquare = 'fas fa-plus-square';
const faQuestionCircle = 'far fa-question-circle';
const faRestore = 'fas fa-trash-restore';
const faSave = 'fas fa-save';
const faSearch = 'fas fa-search';
const faSignInAlt = 'fas fa-sign-in-alt';
const faSignOutAlt = 'fas fa-sign-out-alt';
const faChevronDown = 'fas fa-chevron-down';
const faChevronUp = 'fas fa-chevron-up';
const faStar = 'fas fa-star';
const faStarHalfAlt = 'fas fa-star-half-alt';
const faStarOutline = 'far fa-star';
const faSync = 'fas fa-sync';
const faTable = 'fas fa-table';
const faTag = 'fas fa-tag';
const faList = 'fas fa-list';
const faThumbsUp = 'fas fa-thumbs-up';
const faThumbsUpRegular = 'far fa-thumbs-up';
const faThumbsDown = 'fas fa-thumbs-down';
const faThumbsDownRegular = 'far fa-thumbs-down';
const faTimes = 'fas fa-times';
const faTimesCircle = 'fas fa-times-circle';
const faTrashAlt = 'far fa-trash-alt';
const faTwitter = 'fab fa-twitter';
const faUndo = 'fas fa-undo';
const faUpload = 'fas fa-file-import';
const faHeart = 'fas fa-heart';
const faGlobe = 'fas fa-globe';
const faStickyNote = 'fas fa-sticky-note';
const faMinusSquare = 'fas fa-minus-square';
const faRandom = 'fas fa-random';
const faEquals = 'fas fa-equals';
const faEllipsisV = 'fas fa-ellipsis-v';
const faArrowCircleDown = 'fas fa-arrow-circle-down';
const faExclamationCircle = 'fas fa-exclamation-circle';
const faMinus = 'fas fa-minus';
const faCaretUp = 'fas fa-caret-up';
const faClock = 'far fa-clock';
const faCircle = 'far fa-circle';
const faClone = 'far fa-clone';
const faFlag = 'far fa-flag';
const faPenSquare = 'fas fa-pen-square';
const faExclamationTriangle = 'fas fa-exclamation-triangle';
const faTshirt = 'fas fa-tshirt';
const faExternalLinkAlt = 'fas fa-external-link-alt';
const faBookmarkSolid = 'fas fa-bookmark';
const faBookmark = 'far fa-bookmark';
const faBalanceScaleLeft = 'fas fa-balance-scale-left';
const faGripVertical = 'fas fa-grip-vertical';
const faThumbtack = 'fas fa-thumbtack';
const faInfoCircle = 'fas fa-info-circle';

const faXbox = 'fab fa-xbox';
const faPlaystation = 'fab fa-playstation';
const faSteam = 'fab fa-steam';
const faYoutube = 'fab fa-youtube';
const faDiscord = 'fab fa-discord';
const faGithub = 'fab fa-github';
const faReddit = 'fab fa-reddit';

const faPlay = 'fas fa-play';
const faStop = 'fas fa-stop';
const faCamera = 'fas fa-camera';
const faEye = 'fas fa-eye';
const faEyeSlash = 'fas fa-eye-slash';
const faCheckDouble = 'fas fa-check-double';
const faTrash = 'fas fa-trash';
const faUnlink = 'fas fa-unlink';
const faHistory = 'fas fa-history';
const farStickyNote = 'far fa-sticky-note';

export {
  battleNetIcon,
  stadiaIcon,
  dimEngramIcon as engramIcon,
  dimPowerIcon as powerIndicatorIcon,
  dimPowerAltIcon as powerActionIcon,
  dimHunterIcon as hunterIcon,
  dimTitanIcon as titanIcon,
  dimWarlockIcon as warlockIcon,
  faArchive as archiveIcon,
  faArrowCircleUp as updateIcon,
  faArrowRight as rightArrowIcon,
  faBan as banIcon,
  faBars as menuIcon,
  faBolt as boltIcon,
  faBalanceScaleLeft as compareIcon,
  faCheck,
  faCheckCircle as enabledIcon,
  faCheckCircle as redeemedIcon,
  faCheckCircleRegular as completedIcon,
  faCheckCircleRegular as unselectedCheckIcon,
  faChevronCircleDown as openDropdownIcon,
  faChevronCircleUp,
  faCircleRegular as uncompletedIcon,
  faCog as settingsIcon,
  faCopy as copyIcon,
  faDownload as downloadIcon,
  faEllipsisV as kebabIcon,
  faEnvelope as sendIcon,
  faEraser as clearIcon,
  faLevelUpAlt as levellingIcon,
  faLock as lockIcon,
  faUnlock as unlockedIcon,
  faCaretDown as collapseIcon,
  faPencilAlt as editIcon,
  faPlus as plusIcon,
  faThumbtack as pinIcon,
  faPlusSquare,
  faCaretRight as expandIcon,
  faAngleDoubleLeft as maximizeIcon,
  faAngleDoubleRight as minimizeIcon,
  faPlusCircle as addIcon,
  faQuestionCircle as helpIcon,
  faSave as saveIcon,
  faSearch as searchIcon,
  faSignInAlt as signInIcon,
  faSignOutAlt as signOutIcon,
  faChevronDown as moveDownIcon,
  faChevronUp as moveUpIcon,
  faRestore as restoreIcon,
  faStar as starIcon,
  faStarHalfAlt as halfStarIcon,
  faStarOutline as starOutlineIcon,
  faSync as refreshIcon,
  faTable as spreadsheetIcon,
  faTag as tagIcon,
  faThumbsUp as thumbsUpIcon,
  faThumbsUpRegular,
  faThumbsDown as thumbsDownIcon,
  faThumbsDownRegular,
  faTimes as closeIcon,
  faTimesCircle as disabledIcon,
  faTimesCircle,
  faTrashAlt as deleteIcon,
  faTwitter as twitterIcon,
  faUndo as undoIcon,
  faUpload as revisionsIcon,
  faUpload as uploadIcon,
  faHeart as heartIcon,
  faGlobe as globeIcon,
  faStickyNote as stickyNoteIcon,
  faArrowRight as moveIcon,
  faBookmark as unTrackedIcon,
  faBookmarkSolid as trackedIcon,
  faMinusSquare,
  faRandom,
  faEquals,
  faArrowCircleDown,
  faExclamationCircle,
  faCheckCircle,
  faCaretDown,
  faCaretUp,
  faMinus,
  faClock,
  faCircle,
  faClone,
  faFlag,
  faPenSquare,
  faExclamationTriangle,
  faTshirt,
  faGripVertical as dragHandleIcon,
  faExternalLinkAlt,
  faInfoCircle,
  faXbox,
  faPlaystation,
  faSteam,
  faYoutube,
  faDiscord,
  faGithub,
  faReddit,
  faList,
  faAngleLeft,
  faAngleRight,
  faPlay as startTrackerIcon,
  faStop as stopTrackerIcon,
  faCamera as takeScreenshot,
  faEye as showOptions,
  faEyeSlash as hideOptions,
  faCheck as partiallyComplete,
  faCheckDouble as fullyComplete,
  faTrash as removeSession,
  faAngleDoubleRight as continueTrackerIcon,
  faUnlink as offlineMode,
  faHistory as extendedComplete,
  farStickyNote as addOrderNoteIcon,
};
